function initBenefits() {
    const compareResults = document.querySelector('.compare-quotes-container.rebrand');
    const innerBanner = document.querySelector('section.inner-banner.rebrand');

    if (compareResults) {
        const benefitsgraphic = document.querySelector('.rebrand-graphic');

        if (benefitsgraphic) {
            benefitsgraphic.classList.add('no-graphic');
        }
    }

    if (innerBanner && compareResults) {
        innerBanner.classList.add('rebrand-graphic-inner');
    }
}

document.addEventListener("DOMContentLoaded", function () {
    initBenefits();
});
